import classNames from 'classnames';
import { FC } from 'react';
import ReactDOM from 'react-dom';

import iconClose from '@/assets/icon/icon-close.svg';
import { useCheckBrowser } from '@/hooks/useCheckBrowser';
import { useI18nContext } from '@/i18n/I18n';

import styles from './index.module.less';

/**
 * 检测浏览器版本是否支持写入httponly samesite 的cookie，低版本弹窗提示
 * @param options ByCheckBrowser
 * @returns ReactComponent
 */
const ByCheckBrowser: FC = () => {
  const { browserTipModalVisible, closeBrowserTipModalVisible } =
    useCheckBrowser();
  const [$t] = useI18nContext();

  if (!browserTipModalVisible) {
    return null;
  }
  return ReactDOM.createPortal(
    <section
      className={classNames(
        styles['ban-ip-dialog'],
        {
          [styles.visible]: browserTipModalVisible,
        },
        'cht-ban-ip-dialog',
      )}
    >
      <main className={styles['ban-ip-dialog_container']}>
        <div className={styles['ban-ip-dialog_title']}>
          <article>{$t('notifications')}</article>
          <div
            className={styles['ban-ip-dialog_xxx-wraper']}
            onClick={closeBrowserTipModalVisible}
          >
            <img src={iconClose} alt="icon close" />
          </div>
        </div>
        <div className={styles['ban-ip-dialog_content']}>
          <div>{$t('deviceVersionLowNotice')}</div>
        </div>
      </main>
    </section>,
    window.document.body,
  );
};

export default ByCheckBrowser;
